import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Marker from "../../assets/images/Marker.png";
import TextField from "@mui/material/TextField";
import { setData } from "../../Redux/mainActions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
const style = {
  position: "absolute",
  top: "30%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 320,
  bgcolor: "background.paper",
  border: "none",
  borderRadius: "30px",
  boxShadow: 24,
  fontFamily: "SansX",
  fontSize: "3vh",
  p: 5,
  zIndex: 100000,
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  direction: "rtl",
};

function ModalInfo(props) {
  const { handleOpen, handleClose, open, address, getAdrs, lat, lng } = props;
  const [detail, setDetail] = React.useState("");
  const handleSubmit = async () => {
    // e.preventDefault();
    await props.setData({
      origin_lat: JSON.stringify(lng),
      origin_long: JSON.stringify(lat),
      destination_lat: null,
      destination_long: null,
      description:null
    });
    props.history.push("/ToLoc");
  };
  // React.useEffect(() => {}, []);
  return (
    <div>
      <img
        src={Marker}
        alt="location-icon"
        onClick={handleSubmit}
        style={{
          width: "80px",
          position: "absolute",
          zIndex: "1000",
          marginTop: "35vh",
          marginLeft: "38vw",
        }}
      />
      {/* <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <p id="modal-modal-title" variant="h6" component="h2">
                        ثبت اطلاعات مبدا
                    </p>
                    <TextField sx={{ margin: '1vh' }}
                        InputProps={{
                            readOnly: true,
                        }}
                        defaultValue={address}
                        id="standard-basic"
                        label="آدرس"
                        variant="standard" />
                    <TextField
                        onChange={(e) => setDetail(e.target.value)}
                        sx={{ margin: '1vh' }} id="standard-basic" label="جزییات آدرس" variant="standard" />
                    <Button
                        // onClick={getAdrs}
                        // href="/ToLoc"
                        onClick={() => handleSubmit()}
                        sx={{ fontFamily: 'SansX', minWidth: 200, marginTop: "2vh", marginBottom:'2vh',backgroundColor: '#2BB3C0' }}
                        variant="contained" >
                        ثبت
                    </Button>
                </Box>
            </Modal> */}
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    data: state.data,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setData: (value) => dispatch(setData(value)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ModalInfo));
